import EntityDocumentsTab from 'components/documents/entity-documents-tab.component'

type CarrierDocumentTabProps = {
  companyId: string
}

const CarrierDocumentTab = ({ companyId }: CarrierDocumentTabProps) => {
  return (
    <EntityDocumentsTab
      associateId={companyId}
      internalType="CarrierDocument"
      variant="carrier"
    />
  )
}

export default CarrierDocumentTab
